module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapterhead",
    attrs: {
      "id": "c01"
    }
  }, [_vm._v("CHAPITRE 1"), _c('br'), _vm._v("GEORGES ET HAROLD")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Voici Georges Barnabé et Harold Hébert. Georges, c’est le squelette de droite avec une cravate et les cheveux en brosse. Harold, c’est le squelette aux cheveux fous à gauche, qui porte un t-shirt. Souviens-toi de tout ça..")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/8-2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dans leur dernière aventure, comme tu t’en souviens probablement, Georges et Harold ont commis l’horrible erreur d’essayer de franchir une distorsion spatiotemporelle artificielle sans laisser refroidir le super-bimiflimanatron C-2X906 de leur bébelotruc-ossificateur, ce qui a provoqué un décalage sous-paradoxal alternatif dimensionnel, lequel a ouvert une brèche oppozo-dimensionnelle réelle vers un bio-nanzoflamascarpone zinticulaire sous-omnivateur.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9-1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("En termes scientifiques, ils ont "), _c('em', [_vm._v("gaffé")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mais ne panique pas, même si tout le monde a l’air d’un squelette. Les rayons X sont la conséquence normale d’une brèche oppozo-dimensionnelle réelle. Ne t’en fais pas, ça va sûrement s’arranger…")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tu vois? Qu’est-ce que je t’avais dit?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Georges, Harold et leurs fidèles animaux ont soudain souhaité n’avoir jamais mis les pieds dans le p’tit coin mauve pétrifiant qui était sur le point de les expédier au fond de l’abîme terrifiant de l’inconnu… un voyage qui signifierait probablement leur anéantissement et provoquerait sûrement la destruction de notre civilisation, telle qu’on la connaît…")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mais avant de te raconter cette histoire-là, je dois d’abord te raconter celle-ci…")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/10-1.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42756142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01.vue
// module id = 69
// module chunks = 0